"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcceptersDataStore = void 0;
var GetLetter_1 = require("@CommonFrontend/AcceptFlow/GroupAccept/GetLetter");
var mobx_1 = require("mobx");
var AcceptersDataStore = (function () {
    function AcceptersDataStore($rootScope) {
        var _this = this;
        var _a, _b;
        this.$rootScope = $rootScope;
        this._slots = [];
        this.currentIndex = null;
        this._prefilledNamesEnabled = false;
        this.hasPrefilledName = function (slotPosition) {
            var _a;
            var name = (_a = _this.accepterSlots[slotPosition]) === null || _a === void 0 ? void 0 : _a.name;
            var isDefaultName = name ? name.startsWith("Accepter") : false;
            return _this._prefilledNamesEnabled && !!name && !isDefaultName;
        };
        var initialData = this.$rootScope.initialData;
        if (initialData.hasAcceptEnabled && initialData.accepterSettings) {
            var finalisedAccepters_1 = (_a = initialData.finalisedAccepters) !== null && _a !== void 0 ? _a : [];
            var settings = initialData.accepterSettings;
            var slots_1 = finalisedAccepters_1.map(function (accepter) {
                var _a;
                return {
                    isAccepted: true,
                    name: accepter.name,
                    signature: accepter.esignature,
                    initials: (_a = accepter.einitials) !== null && _a !== void 0 ? _a : "",
                    acceptedAt: accepter.acceptedAt,
                };
            });
            var finalisedAccepterNames_1 = slots_1.map(function (s) { return s.name; });
            this._prefilledNamesEnabled = (_b = settings.enablePrefilledNames) !== null && _b !== void 0 ? _b : false;
            var prefilledNames = settings.enablePrefilledNames && settings.prefilledNames ? settings.prefilledNames : [];
            var unusedPrefilledNames = prefilledNames.filter(function (pa) { return !finalisedAccepterNames_1.includes(pa); });
            unusedPrefilledNames.forEach(function (n, index) {
                return slots_1.push({
                    name: n ? n : "Accepter ".concat((0, GetLetter_1.getLetter)(index + finalisedAccepters_1.length)),
                    isAccepted: false,
                    signature: "",
                    initials: "",
                    acceptedAt: "",
                });
            });
            var numberOfEmptySlots = settings.number - (slots_1 === null || slots_1 === void 0 ? void 0 : slots_1.length);
            var totalFilledAndPrefilled = finalisedAccepters_1.length + unusedPrefilledNames.length;
            for (var i = 0; i < numberOfEmptySlots; i++) {
                slots_1.push({
                    isAccepted: false,
                    name: "Accepter ".concat((0, GetLetter_1.getLetter)(totalFilledAndPrefilled + i)),
                    signature: "",
                    initials: "",
                    acceptedAt: "",
                });
            }
            this._slots = slots_1;
        }
    }
    Object.defineProperty(AcceptersDataStore.prototype, "accepterSlots", {
        get: function () {
            return this._slots;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AcceptersDataStore.prototype, "accepterIndex", {
        get: function () {
            return this.currentIndex;
        },
        enumerable: false,
        configurable: true
    });
    AcceptersDataStore.prototype.updateSlotSignature = function (index, payload) {
        if (this.currentIndex === null) {
            this.currentIndex = index;
        }
        if (this.currentIndex === index) {
            var clone = __spreadArray([], __read(this._slots), false);
            clone.splice(index, 1, __assign(__assign({}, this._slots[index]), { signature: payload, acceptedAt: new Date().toString(), isCritical: false }));
            this._slots = clone;
        }
    };
    AcceptersDataStore.prototype.updateSlotInitials = function (index, payload) {
        if (this.currentIndex === null) {
            this.currentIndex = index;
        }
        if (this.currentIndex === index) {
            var clone = __spreadArray([], __read(this._slots), false);
            clone.splice(index, 1, __assign(__assign({}, this._slots[index]), { initials: payload, acceptedAt: new Date().toString(), isCritical: false }));
            this._slots = clone;
        }
    };
    AcceptersDataStore.prototype.clearSlot = function (index) {
        if (this.currentIndex === index) {
            var clone = __spreadArray([], __read(this._slots), false);
            var existingData = this._slots[index];
            if (existingData) {
                var signature = existingData.signature, initials = existingData.initials, acceptedAt = existingData.acceptedAt, rest = __rest(existingData, ["signature", "initials", "acceptedAt"]);
                clone.splice(index, 1, __assign({}, rest));
                this._slots = clone;
                this.currentIndex = null;
            }
        }
    };
    AcceptersDataStore.prototype.isSlotLocked = function (index) {
        if (this.currentIndex === null) {
            return false;
        }
        return this.currentIndex !== index;
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], AcceptersDataStore.prototype, "_slots", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], AcceptersDataStore.prototype, "currentIndex", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], AcceptersDataStore.prototype, "_prefilledNamesEnabled", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], AcceptersDataStore.prototype, "accepterSlots", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], AcceptersDataStore.prototype, "accepterIndex", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number, String]),
        __metadata("design:returntype", void 0)
    ], AcceptersDataStore.prototype, "updateSlotSignature", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number, String]),
        __metadata("design:returntype", void 0)
    ], AcceptersDataStore.prototype, "updateSlotInitials", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], AcceptersDataStore.prototype, "clearSlot", null);
    return AcceptersDataStore;
}());
exports.AcceptersDataStore = AcceptersDataStore;
